import { ReactNode } from "react";

import { Heading, Stack } from "@seneca/senekit";

type Props = {
  children: {
    title: ReactNode;
    setting: ReactNode;
  };
};

export default function SettingLayout({ children: { title, setting } }: Props) {
  return (
    <Stack space="12">
      <Heading level="5" weight="bold">
        {title}
      </Heading>
      {setting}
    </Stack>
  );
}
